// extracted by css-extract-rspack-plugin
export default {"container":"DonationMatchRequestDetails_container__jRrxi","leftPanel":"DonationMatchRequestDetails_leftPanel__AoEE1","rightPanel":"DonationMatchRequestDetails_rightPanel__htDGC"};